import { render, staticRenderFns } from "./InfoTypeSection.vue?vue&type=template&id=b38c3f20&"
import script from "./InfoTypeSection.vue?vue&type=script&lang=ts&"
export * from "./InfoTypeSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports